@if (open) {
  <aside class="assistant-panel" role="complementary" [attr.aria-label]="'Assistente' | translate">

    <header class="assistant-panel__bar">
      <span class="bar__avatar" aria-hidden="true"><mat-icon class="s-22" fontSet="material-icons-round">auto_awesome</mat-icon></span>
      <div class="bar__titles">
        <h2 class="bar__name">{{ 'Assistente' | translate }}</h2>
        @if (context?.domain?.name) {
          <p class="bar__company">{{ context.domain.name }}</p>
        }
      </div>
      <div class="bar__actions">
        @if (messages.length) {
          <button mat-button type="button" class="bar__new" (click)="assistant.newConversation()">
            <mat-icon class="s-18">add_comment</mat-icon>
            {{ 'Nuova chat' | translate }}
          </button>
        }
        <button mat-icon-button type="button" class="bar__close" (click)="assistant.open.next(false)"
          [matTooltip]="'Chiudi' | translate" [attr.aria-label]="'Chiudi' | translate">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </header>

    <section class="assistant-panel__context" aria-live="polite">
      @if (context === null) {
        <p class="context__muted">{{ 'Controllo cosa stai guardando…' | translate }}</p>
      } @else if (!context.available) {
        <p class="context__unavailable">
          <mat-icon inline>block</mat-icon>
          {{ context.error?.message }}
        </p>
      } @else if (context.entity) {
        <div class="context__entity">
          <span class="context__eye" aria-hidden="true"><mat-icon class="s-18">visibility</mat-icon></span>
          <div class="context__texts">
            <p class="context__label">{{ 'Sto guardando' | translate }}: {{ context.entity.label | translate }}</p>
            <p class="context__title">{{ context.entity.title }}</p>
          </div>
        </div>
      } @else if (context.new_entity) {
        <div class="context__entity">
          <span class="context__eye" aria-hidden="true"><mat-icon class="s-18">add_circle_outline</mat-icon></span>
          <div class="context__texts">
            <p class="context__label">{{ 'Stai creando' | translate }}: {{ context.new_entity.label | translate }}</p>
            <p class="context__title">{{ 'Nuova, non ancora salvata' | translate }}</p>
          </div>
        </div>
      } @else {
        <p class="context__muted">
          {{ 'Apri il dettaglio di un pacchetto per lavorare su criteri e prezzi.' | translate }}
        </p>
      }
    </section>

    <div class="assistant-panel__scroller" #scroller>
      @if (!messages.length) {
        <div class="assistant-panel__empty">
          @if (suggestions.length) {
            <p class="empty__lead">{{ intro | translate }}</p>
            @if (suggestionsLoading) {
              <p class="empty__thinking" role="status">
                <span class="typing" aria-hidden="true"><span></span><span></span><span></span></span>
                {{ 'Sto guardando il pacchetto per consigli più precisi…' | translate }}
              </p>
            }
            <ul class="empty__suggestions" [class.is-refining]="suggestionsLoading">
              @for (suggestion of suggestions; track suggestion.kind + suggestion.label) {
                <li>
                  <button type="button" class="suggestion" [attr.data-kind]="suggestion.kind" (click)="submitSuggestion(suggestion)" [disabled]="sending">
                    <mat-icon fontSet="material-icons-round" class="suggestion__icon s-16" aria-hidden="true">{{ suggestionIcon(suggestion) }}</mat-icon>
                    <span>{{ suggestion.label }}</span>
                  </button>
                </li>
              }
            </ul>
          } @else if (context?.available) {
            <p class="empty__lead">{{ 'Scrivi una domanda per iniziare.' | translate }}</p>
          }
        </div>
      }

      <ol class="assistant-panel__messages">
        @for (message of messages; track message.id; let index = $index) {
          <li class="message" [class]="'message--' + message.role"
            [class.message--run-start]="startsAssistantRun(index)"
            [attr.data-message-id]="message.id">

            @if (message.role !== 'user') {
              <span class="message__avatar" [class.message__avatar--hidden]="!startsAssistantRun(index)" aria-hidden="true">
                <mat-icon class="s-18" fontSet="material-icons-round">auto_awesome</mat-icon>
              </span>
            }

            <div class="message__body">
              @if (message.action) {
                <assistant-action-card [item]="message"
                  (confirm)="assistant.confirm($event)"
                  (cancel)="assistant.cancel($event)">
                </assistant-action-card>
              } @else if (message.clientAction?.type === 'next_step') {
                <div class="step-handoff" [class.step-handoff--done]="message.clientActionDone">
                  @if (message.clientAction.reason) {
                    <p class="step-handoff__reason">
                      <mat-icon class="s-18" fontSet="material-icons-round" aria-hidden="true">task_alt</mat-icon>
                      <span>{{ message.clientAction.reason }}</span>
                    </p>
                  }
                  <button mat-flat-button type="button" class="step-handoff__go"
                    [disabled]="message.clientActionDone || sending" (click)="assistant.runClientAction(message)">
                    <span>{{ message.clientAction.label }}</span>
                    <mat-icon class="s-18" fontSet="material-icons-round" iconPositionEnd aria-hidden="true">arrow_downward</mat-icon>
                  </button>
                </div>
              } @else if (message.role === 'notice') {
                <div class="notice" [class]="'notice--' + message.errorCode" role="alert">
                  <p>{{ message.text }}</p>
                  @if (retryable(message.errorCode)) {
                    <button mat-button type="button" class="notice__retry" (click)="assistant.retry()" [disabled]="sending">
                      {{ 'Riprova' | translate }}
                    </button>
                  }
                </div>
              } @else if (message.role === 'assistant') {
                <div class="bubble bubble--assistant">
                  @for (segment of message.text | assistantSegments; track $index) {
                    @if (segment.kind === 'table') {
                      <assistant-table class="bubble__table" [table]="segment.table"></assistant-table>
                    } @else {
                      <div class="bubble__md" [innerHTML]="segment.html"></div>
                    }
                  }
                </div>
              } @else {
                <div class="bubble bubble--user">
                  @if (message.text) {
                    <span class="bubble__text">{{ message.text }}</span>
                  }
                  @if (message.attachments?.length) {
                    <ul class="bubble__files" [attr.aria-label]="'File allegati' | translate">
                      @for (attachment of message.attachments; track attachment.id) {
                        <li class="file-chip file-chip--sent">
                          <mat-icon class="s-16" fontSet="material-icons-round" aria-hidden="true">{{ attachmentIcon(attachment.name) }}</mat-icon>
                          <span class="file-chip__name">{{ attachment.name }}</span>
                          <span class="file-chip__meta">{{ attachment.lines }} {{ (attachment.lines === 1 ? 'riga' : 'righe') | translate }}</span>
                        </li>
                      }
                    </ul>
                  }
                </div>
              }

              @if (endsRun(index) && !(sending && index === messages.length - 1 && message.role === 'user')) {
                <time class="message__time" [attr.datetime]="message.at.toISOString()">{{ message.at | date: 'HH:mm' }}</time>
              }
            </div>
          </li>
        }

        @if (sending) {
          <li class="message message--assistant message--run-start">
            <span class="message__avatar" aria-hidden="true"><mat-icon class="s-18" fontSet="material-icons-round">auto_awesome</mat-icon></span>
            <div class="message__body">
              <div class="bubble bubble--assistant bubble--working" role="status">
                <span class="typing" aria-hidden="true"><span></span><span></span><span></span></span>
                <span>
                  {{ workingLabel | translate }}…
                  @if (showElapsed) {
                    <span class="working__elapsed">({{ elapsedSeconds }} s)</span>
                  }
                </span>
              </div>
            </div>
          </li>
        }
      </ol>
    </div>

    <form class="assistant-panel__composer" (ngSubmit)="submit()"
      (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
      @if (drafts.length) {
        <ul class="composer__files" [attr.aria-label]="'File da inviare' | translate">
          @for (file of drafts; track file.key) {
            <li class="file-chip" [class.file-chip--error]="file.error" [class.file-chip--loading]="!file.attachment && !file.error">
              <mat-icon class="s-16" fontSet="material-icons-round" aria-hidden="true">{{ file.error ? 'error_outline' : attachmentIcon(file.name) }}</mat-icon>
              <span class="file-chip__name" [title]="file.name">{{ file.name }}</span>
              <span class="file-chip__meta" role="status">
                @if (file.error) {
                  {{ file.error }}
                } @else if (file.attachment) {
                  {{ formatSize(file.size) }} · {{ file.attachment.lines }} {{ (file.attachment.lines === 1 ? 'riga' : 'righe') | translate }}
                } @else {
                  {{ 'Lettura…' | translate }}
                }
              </span>
              <button type="button" class="file-chip__remove" (click)="removeDraft(file)" [attr.aria-label]="('Togli' | translate) + ' ' + file.name">
                <mat-icon class="s-16">close</mat-icon>
              </button>
            </li>
          }
        </ul>
      }
      <div class="composer__field" [class.composer__field--disabled]="context?.available === false" [class.composer__field--dropping]="dropping">
        <input #fileInput type="file" class="cdk-visually-hidden" tabindex="-1" multiple [accept]="attachmentAccept" (change)="onFilesPicked(fileInput)">
        <button type="button" class="composer__attach" (click)="openFilePicker()" [disabled]="!canAttach"
          [attr.aria-label]="'Allega un file con le istruzioni (txt, csv, Excel, Word)' | translate"
          [title]="'Allega un file con le istruzioni (txt, csv, Excel, Word)' | translate">
          <mat-icon class="s-20" fontSet="material-icons-round">attach_file</mat-icon>
        </button>
        <label class="cdk-visually-hidden" for="assistant-composer">{{ 'Messaggio per l\'assistente' | translate }}</label>
        <textarea id="assistant-composer" #composer name="draft" rows="1" maxlength="4000"
          [(ngModel)]="draft"
          [disabled]="context?.available === false"
          [placeholder]="'Scrivi una richiesta' | translate"
          (input)="autosize()"
          (keydown)="onComposerKeydown($event)"
          aria-describedby="assistant-composer-hint"></textarea>
        <button type="submit" class="composer__send" [disabled]="!canSend" [attr.aria-label]="'Invia' | translate">
          <mat-icon class="s-20">arrow_upward</mat-icon>
        </button>
      </div>
      <p class="composer__hint" id="assistant-composer-hint">
        @if (dropping) {
          {{ 'Rilascia il file per allegarlo' | translate }}
        } @else {
          {{ 'Invio per inviare, Maiusc+Invio per andare a capo' | translate }}
        }
      </p>
    </form>
  </aside>
}
